export default __webpack_public_path__ + "static/media/man_icon.46701a2a.svg";